<div class="tw-flex tw-flex-col tw-h-full tw-bg-p-content-background tw-border-r tw-border-p-content-border">
  <div class="tw-p-4 tw-border-b tw-border-p-content-border">
    <a [routerLink]="['/']" class="tw-flex tw-items-center tw-justify-center">
      <img
        src="/assets/logo/ageras_storebuddy_logo.svg"
        class="tw-h-12 tw-invert dark:tw-invert-0"
        alt="Storebuddy logo"
      />
    </a>
  </div>

  <div class="tw-flex-grow tw-overflow-y-auto tw-py-4 [&_p-panelmenu-panel]:!tw-border-0">
    <sb-search-bar class="tw-px-4 tw-pb-4" />

    <p-panelMenu [model]="panelMenuItems()" styleClass="[&_p-panelmenu-panel]:!tw-border-0">
      <ng-template #item let-item>
        <a
          pButton
          text
          [severity]="item.active ? 'primary' : 'secondary'"
          [routerLink]="item.routerLink"
          class="!tw-justify-start tw-w-full"
        >
          <fa-icon
            [icon]="[item.iconPrefix || 'fal', item.icon]"
            class="tw-mr-3"
            [ngClass]="item.active ? 'tw-text-p-color-primary' : 'tw-text-p-muted-color'"
            [fixedWidth]="true"
          ></fa-icon>

          <span class="tw-text-ellipsis tw-overflow-hidden tw-text-nowrap">{{ item.label }}</span>

          @if (item.items) {
            <fa-icon
              [icon]="['fal', 'chevron-down']"
              class="tw-ml-auto"
              [ngClass]="item.active ? 'tw-text-p-color-primary' : 'tw-text-p-muted-color'"
              [fixedWidth]="true"
              [rotate]="item.expanded ? '180' : '0'"
            ></fa-icon>
          }
        </a>
      </ng-template>
    </p-panelMenu>
  </div>

  <div class="tw-p-2 tw-border-t tw-border-p-content-border tw-flex tw-flex-col tw-gap-2">
    <button
      pButton
      type="button"
      text
      severity="secondary"
      class="!tw-justify-start tw-w-full"
      (click)="businessMenu.toggle($event)"
    >
      <fa-icon [icon]="['fal', 'store']" class="tw-text-p-muted-color tw-mr-2" [fixedWidth]="true"></fa-icon>
      <span class="tw-text-ellipsis tw-overflow-hidden tw-text-nowrap">
        {{ (defaultStore$ | async)?.attributes.name || 'Alle' | middleEllipsis }}
      </span>
      <fa-icon [icon]="['far', 'angle-down']" class="tw-text-p-muted-color tw-ml-auto" [fixedWidth]="true"></fa-icon>
    </button>

    <div class="tw-flex tw-gap-2 tw-justify-between">
      <!-- Account menu -->
      <p-button
        type="button"
        text
        pTooltip="Firma indstillinger"
        tooltipPosition="top"
        (click)="accountMenu.toggle($event)"
      >
        <ng-template #icon>
          <fa-icon
            [icon]="['fal', 'building']"
            class="tw-text-p-muted-color"
            [class.!tw-text-p-color-primary]="accountMenu.visible || activeRouteGroup() === 'account'"
            [fixedWidth]="true"
          ></fa-icon
        ></ng-template>
      </p-button>

      <p-button
        (click)="navigateToSettingsPage()"
        target="_blank"
        text
        [pTooltip]="
          !activeStoreId() ? 'Vælg en forretning for at se forretningsindstillinger' : 'Forretningsindstillinger'
        "
        tooltipPosition="top"
        [disabled]="!activeStoreId()"
      >
        <ng-template #icon>
          <fa-icon
            [icon]="['fal', 'gear']"
            class="tw-text-p-muted-color"
            [class.!tw-text-p-color-primary]="activeRouteGroup() === 'settings'"
            [fixedWidth]="true"
          ></fa-icon>
        </ng-template>
      </p-button>

      <p-button (click)="navigateToSupportPage()" target="_blank" text pTooltip="Hjælp" tooltipPosition="top">
        <ng-template #icon>
          <fa-icon [icon]="['fal', 'circle-question']" class="tw-text-p-muted-color" [fixedWidth]="true"></fa-icon>
        </ng-template>
      </p-button>

      @if (!isProductionEnvironment()) {
        <p-button type="button" text pTooltip="Skift tema" tooltipPosition="top" (click)="toggleTheme()">
          <ng-template #icon>
            <fa-icon
              [icon]="['fal', 'moon']"
              class="tw-text-p-muted-color dark:tw-hidden"
              [fixedWidth]="true"
            ></fa-icon>
            <fa-icon
              [icon]="['fal', 'sun']"
              class="tw-text-gray-300 tw-hidden dark:tw-block"
              [fixedWidth]="true"
            ></fa-icon>
          </ng-template>
        </p-button>
      }
    </div>
  </div>
</div>

<p-menu #accountMenu [popup]="true" [model]="accountMenuItems()"></p-menu>

<p-menu #businessMenu [popup]="true" [model]="businessMenuItems()" [styleClass]="'tw-w-[300px]'">
  <ng-template pTemplate="item" let-item>
    <a
      (click)="item.command ? item.command($event) : null"
      [routerLink]="item.routerLink || null"
      class="p-menuitem-link tw-flex tw-justify-between !tw-pr-1 tw-pl-3 !tw-w-full tw-cursor-pointer tw-items-center tw-h-10"
      [ngClass]="{ 'tw-group': item.showSettingsButton }"
    >
      <span
        class="tw-text-ellipsis tw-overflow-hidden tw-text-nowrap"
        [ngClass]="{ 'tw-text-p-color-primary': item.active }"
      >
        {{ item.label }}
      </span>

      @if (item.showWarning) {
        <fa-icon class="tw-text-yellow-500 tw-ml-2" [icon]="['fas', 'info-circle']" [fixedWidth]="true"></fa-icon>
      }

      @if (item.showSettingsButton) {
        <div class="tw-flex">
          <button
            pButton
            type="button"
            text
            size="small"
            class="!tw-min-w-0"
            pTooltip="Indstillinger"
            tooltipPosition="left"
            (click)="
              $event.stopPropagation();
              item.settingsCommand && item.settingsCommand($event);
              businessMenu.toggle($event)
            "
          >
            <fa-icon
              [icon]="['fal', 'gear-complex']"
              [fixedWidth]="true"
              class="tw-text-p-muted-color tw-opacity-0 group-hover:tw-opacity-100"
            ></fa-icon>
          </button>
        </div>
      }

      @if (item.showAddIcon) {
        <fa-icon [icon]="['far', 'plus-circle']" [fixedWidth]="true" class="tw-text-p-color tw-mr-2.5"></fa-icon>
      }
    </a>
  </ng-template>
</p-menu>
